import React from 'react';
import { User, ArrowRight, Receipt, Sparkles } from 'lucide-react';
import { OsCard, AnimatedNumber } from '../theme';
import AgentAdviceRail from '../../components/AgentAdviceRail';

/* Client home — their Kitxens account at a glance. */

const money = (v) => `$${(Number(v) || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export default function ClientHome({ client, isEs, enter }) {
  const c = client || {};
  return (
    <div data-testid="client-home">
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <OsCard className="p-5 os3-rise">
          <p className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] font-bold" style={{ color: 'var(--os-ink-faint)' }}>
            <Receipt className="w-3.5 h-3.5" style={{ color: 'var(--os-accent)' }} /> {isEs ? 'Tus compras' : 'Your purchases'}
          </p>
          <p className="mt-2 text-[26px] font-black tabular-nums" style={{ color: 'var(--os-ink)' }}>
            <AnimatedNumber value={c.payments || 0} />
          </p>
          <p className="text-[12px]" style={{ color: 'var(--os-ink-soft)' }}>
            {c.payments ? <>{isEs ? 'Total invertido' : 'Total invested'}: <b style={{ color: 'var(--os-ink)' }}>{money(c.total_spent)}</b>{c.last_product ? ` · ${c.last_product}` : ''}</>
              : (isEs ? 'Aún no tienes compras registradas.' : 'No purchases on record yet.')}
          </p>
        </OsCard>
        <OsCard className="p-5 os3-rise" style={{ animationDelay: '60ms' }}>
          <p className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] font-bold" style={{ color: 'var(--os-ink-faint)' }}>
            <Sparkles className="w-3.5 h-3.5" style={{ color: 'var(--os-accent)' }} /> {isEs ? 'Tu área de cliente' : 'Your client area'}
          </p>
          <p className="mt-2 text-[13.5px] leading-relaxed" style={{ color: 'var(--os-ink-soft)' }}>
            {isEs ? 'Reportes, descargas y todo lo que Kitxens ha preparado para ti — en un solo lugar.' : 'Reports, downloads and everything Kitxens prepared for you — in one place.'}
          </p>
        </OsCard>
      </div>
      <AgentAdviceRail audience="client" isEs={isEs} className="mt-5" onCardClick={() => enter({ id: 'client' })} />
      <button onClick={() => enter({ id: 'client' })} data-testid="client-enter-btn"
        className="mt-6 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-[14px] font-bold text-white transition-all hover:opacity-90 os3-lift"
        style={{ background: 'var(--os-accent)', boxShadow: '0 0 24px 0 var(--os-glow)' }}>
        <User className="w-4 h-4" /> {isEs ? 'Entrar a Mi Kitxens' : 'Enter My Kitxens'} <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
